import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.jsx";

// Global stylesheets — loaded once, shared across all routes.
import "./styles/colors_and_type.css";
import "./styles/site.css";
// Per-service interactive stylesheets are imported by their respective page
// components (Faza 6d — Vite splits them into route-specific chunks, reducing
// initial CSS payload by ~40% for users who don't visit every subpage).

const root = document.getElementById("root");
// If the route was prerendered (Faza 5c — playwright-based postbuild), the root
// already contains rendered HTML. Hydrate to attach React listeners. Otherwise
// (e.g. dev mode) mount fresh.
if (root.hasChildNodes()) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
